import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import img1 from "../../images/modal.png";
import { useLangContext } from '../../i18n/ProvideLang';
import { useForm } from 'react-hook-form';
import AppServices from '../../services/general/appServices';
import { useNavigate } from 'react-router-dom';
import Utils from '../../services/utils';

const ServiceModal = ({show, setShow, card, image}) => {
    const {localizationsItems} = useLangContext();
    const [visible, setVisible] = useState(false)
	const [loading, setLoading] = useState();

    const navigate = useNavigate();

    const {handleSubmit, register, reset, formState: {errors}} = useForm();

    const CustomSubmit = async (data) => {
        setLoading(true);

        let newData = {
			...data,
            service_name: card.title
        }

        let query = new URLSearchParams(window.location.search);

        if(query.toString()){
            query.get('utm_source') && (newData.utm_source = query.get('utm_source'));
            query.get('utm_medium') && (newData.utm_medium = query.get('utm_medium'))
            query.get('utm_campaign') && (newData.utm_campaign = query.get('utm_campaign'))
            query.get('utm_content') && (newData.utm_content = query.get('utm_content'))
            query.get('utm_term') && (newData.utm_term = query.get('utm_term'))
        }else{
            Utils.getCookie('utm_source') && newData.append('utm_source', Utils.getCookie('utm_source'));
            Utils.getCookie('utm_medium') && newData.append('utm_medium', Utils.getCookie('utm_medium'));
            Utils.getCookie('utm_campaign') && newData.append('utm_campaign', Utils.getCookie('utm_campaign'));
            Utils.getCookie('utm_content') && newData.append('utm_content', Utils.getCookie('utm_content'));
            Utils.getCookie('utm_term') && newData.append('utm_term', Utils.getCookie('utm_term'));
        }

        const res = await AppServices.request(newData);

        if(res.statusCode === 200){
            setVisible(true);
            setTimeout(() => {
                setVisible(false)
                reset();
            }, 3000);
            navigate(`${window.location.pathname}#success`)
        }else{
            console.log(res)
        }
        setLoading(false)
    }

    const handleClose = () => {
		setShow(false);
	}

  return (
    <Modal show={show} onHide={handleClose} centered className='modal-main-worker'>
        <Modal.Header className="p-0">
            <button type="button" className="btn-close" onClick={handleClose}>
                <i className="fa-solid fa-xmark"></i>
            </button>
        </Modal.Header>
        <Modal.Body>
            <div className='service-modal'>
                <div className='service-content'>
                    <div className='flex'>
                        <img src={card.image} alt="" />
                        <h3>{card.title}</h3>
                    </div>
                    <div>
                        <div dangerouslySetInnerHTML={{__html: card.description}}></div>
                    </div>
                </div>
                <div className='service-form'>
                    <div className={loading ? 'form-content isLoading' : 'form-content'}>
                        <h3>{localizationsItems?.modal_title}</h3>
                        <p>{localizationsItems?.modal_content}</p>
                        <form onSubmit={handleSubmit(CustomSubmit)}>
                            <div className="form-field">
                                <input {...register('name', {required: true})} name='name' type="text" placeholder={localizationsItems?.name} className="input bdr-b required"/>
                            </div>
                            <div className="form-field">
                                <input {...register('phone', {required: true})} name='phone' type="text" placeholder={localizationsItems?.phone} className="input bdr-b required"/>
                            </div>
                            <div className="banner-btn-creative col-md-12">
                                <button type="submit" className="btn-creative">{localizationsItems?.send}</button>
                            </div>
                        </form>
                    </div>
                    <div className={visible ? 'form-success form-success-visible' : 'form-success'}>
                        <i className='fa fa-check-circle'></i>
                        <h1>{localizationsItems?.thanks}</h1>
                        <p>{localizationsItems?.success_request}</p>
                    </div>
                </div>
            </div>
        </Modal.Body>
        <div className='modal-img worker-modal-img'>
            <img src={image ? image : img1} alt="" />
        </div>
    </Modal>
  )
}

export default ServiceModal